const BlogContent = [
  {
    images: "",
    title: "FUTURE OF EDUCATION",
    category: "Product",
  },
  {
    images: "",
    title: "OUR WORKFLOW",
    category: "Team",
  },

  {
    images: "",
    title: "DiGiLABS STORY",
    category: "Team",
  },
];

export default BlogContent;
